/* eslint-disable no-redeclare */
import { Integer, JourneyId } from '@hc-frontend/core-types';
import { z } from 'zod';

import { PlateName } from './plate-name';

export const UserJourney = z.object({
  id: JourneyId,
  progress: Integer,
});
export type UserJourney = z.infer<typeof UserJourney>;

export const UserJourneyPlate = UserJourney.extend({
  currentPlate: PlateName,
});
export type UserJourneyPlate = z.infer<typeof UserJourneyPlate>;
